import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DictionaryAPIService } from './dictionary-api.service';
import { ErrorsSevice } from './errors.service';
import { FormBuilderService } from './form-builder.service';
import { FormMessageBulderService } from './form-message-builder.service';
import { LanguageService } from './languages.service';
import { LoginAPIService } from './login-api.service';
import { LoginCommonService } from './login-common.service';
import { NavigationService } from './navigation.service';

@NgModule({
  imports: [ReactiveFormsModule, ModalModule.forRoot()],
  providers: [
    NavigationService,
    DictionaryAPIService,
    FormMessageBulderService,
    FormBuilderService,
    LoginAPIService,
    LoginCommonService,
    LanguageService,
    ErrorsSevice,
  ],
})
export class CommonServicesModule {}
